import React, { useState, useRef, useLayoutEffect } from 'react';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import Label from '@/components/form/Label/Label';
import { Button, Box } from '@mui/material';
import { Formik, Form, Field } from 'formik';
import { useNavigate } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import { useDispatch } from 'react-redux';
import { setUser } from '@/redux/actions/userActions';
import { Link } from 'react-router-dom';
import '@/components/pages/WorkspaceMap/views/WorkspaceMapView.scss';

export const AuthModal = props => {
  const { isOpen, onClose, languageData, onGoogleLogin } = props;
  const [googleLoginSuccessMessage, setGoogleLoginSuccessMessage] =
    useState(false);
  const authColumnRef = useRef(null);
  const [googleButtonWidth, setGoogleButtonWidth] = useState(400);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const goToSignUp = email => {
    console.log('este es el email: ', email);
    navigate('/signup/' + email);
  };

  const initialValues = {
    email: '',
  };

  const onSubmit = (values, { setSubmitting }) => {
    console.log('Email ingresado:', values.email);
    goToSignUp(values.email);
  };

  const handleSuccess = async credentialResponse => {
    try {
      const idToken = credentialResponse.credential;
      console.log('ID Token de Google:', idToken);
      const base64Url = idToken.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        window
          .atob(base64)
          .split('')
          .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join(''),
      );

      const googleUserDetails = JSON.parse(jsonPayload);
      setGoogleLoginSuccessMessage(true);
      const tokenData = await onGoogleLogin({
        email: googleUserDetails.email,
        googleToken: idToken,
      });

      console.log('Token OAuth recibido:', tokenData);

      const userData = {
        name: googleUserDetails?.name,
        lastName: '',
        email: googleUserDetails?.email,
        user_id: tokenData?.user_details?.user_id || 2,
        google: true,
      };

      dispatch(setUser(userData));

      console.log('viending: ', googleLoginSuccessMessage);

      localStorage.setItem('user', JSON.stringify(userData));
      localStorage.setItem('access_token', tokenData.access_token);
      localStorage.setItem('refresh_token', tokenData.refresh_token);
      localStorage.setItem(
        'auth_data',
        JSON.stringify({
          token_type: tokenData.token_type,
          expires_in: tokenData.expires_in,
          scope: tokenData.scope,
        }),
      );

      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        //onClose();
      }, 1000);
    } catch (error) {
      console.error('Error en login con Google:', error);
    }
  };

  const handleError = () => {
    console.log('Login Failed');
  };

  const loading = false;

  useLayoutEffect(() => {
    if (!isOpen) return undefined;
    const el = authColumnRef.current;
    if (!el) return undefined;

    const updateWidth = () => {
      const w = Math.floor(el.getBoundingClientRect().width);
      if (w > 0) {
        // GSI renderButton width: min 240px, max 400px (API hard cap)
        setGoogleButtonWidth(Math.min(Math.max(w, 240), 400));
      }
    };

    updateWidth();
    const ro = new ResizeObserver(updateWidth);
    ro.observe(el);
    return () => ro.disconnect();
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <FlexContainer
      className={
        'AuthModal pos-fixed align-items-center justify-center left0 right0 bottom0'
      }
      style={{
        zIndex: 1000,
      }}
      onClick={onClose}
    >
      <FlexContainer
        className={'flex-column bgWhite border-rad10px pad40 width100'}
        onClick={e => e.stopPropagation()}
      >
        <FlexContainer className="flex-column align-items-center margb30">
          <FlexContainer className="flex-column">
            <img
              src={'/Logotipo_Popnest.png'}
              alt={''}
              className="margtb10 width-65px height-40px"
              style={{
                backgroundColor: 'rgba(255,255,255,0.1)',
              }}
            />
          </FlexContainer>
          <Label className="text-24 text-center fontBlack">
            <strong>
              {languageData === 'EN' ? 'Join Popnest' : 'Únete a Popnest'}
            </strong>
          </Label>
        </FlexContainer>

        <Box ref={authColumnRef} className="AuthModal-authColumn">
          <Box
            className="AuthModal-googleLoginWrap margb-16"
            sx={{
              width: '100%',
              minWidth: 0,
              boxSizing: 'border-box',
            }}
          >
            {/* GSI max width 400px; this column matches email + CTA so nothing looks narrower */}
            <GoogleLogin
              onSuccess={handleSuccess}
              onError={handleError}
              useOneTap
              theme="outline"
              shape="rectangular"
              width={String(googleButtonWidth)}
              use_fedcm_for_button={false}
              containerProps={{
                style: {
                  width: '100%',
                  display: 'block',
                  boxSizing: 'border-box',
                },
              }}
            />
          </Box>
          {googleLoginSuccessMessage && (
            <FlexContainer className="bgGreen100 border-rad8px flex-column flex-container fontWhite margt10 padtb10 text-center">
              <strong>
                {languageData === 'EN'
                  ? 'Login Successfully. Please wait...'
                  : 'Su sesión fue iniciada correctamente'}
              </strong>
            </FlexContainer>
          )}

          <FlexContainer className={'flex-column margb20 margt10'}>
          <Formik initialValues={initialValues} onSubmit={onSubmit}>
            {({ isSubmitting, values }) => (
              <Form className="width100">
                <Box mb={1} position="relative">
                  <Field
                    type="email"
                    name="email"
                    placeholder={
                      languageData === 'EN'
                        ? 'Enter email address'
                        : 'Ingresa tu email'
                    }
                    className={
                      'border-rad8px  margt16 width100 pad14 fontBlack text-15 boxSizing_borderBox outlineNone'
                    }
                    style={{
                      backgroundColor: 'rgba(255,255,255,0)',
                      border: '1px solid rgba(188,188,188,0.4)',
                      transition: 'all 0.2s ease',
                    }}
                    onBlur={e => {
                      e.target.style.backgroundColor = 'rgba(255,255,255,0.12)';
                      e.target.style.borderColor = 'rgba(255,255,255,0.3)';
                      e.target.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
                    }}
                  />
                </Box>

                <Button
                  className={'bgGradientSignUpPurple'}
                  type="submit"
                  fullWidth
                  sx={{
                    mt: '20px',
                    mb: '20px',
                    py: 0.8,
                    color: 'white',
                    borderRadius: '10px',
                    textTransform: 'none',
                    transition: 'all 0.2s ease',
                    fontSize: '14px',
                    '&:hover': {
                      boxShadow: '0 6px 16px rgba(248, 87, 166, 0.5)',
                      transform: 'translateY(-1px)',
                    },
                    '&:disabled': {
                      opacity: 0.7,
                    },
                  }}
                  disabled={loading || isSubmitting}
                  onClick={() => {
                    console.log('Email al hacer clic:', values.email);
                  }}
                >
                  {loading || isSubmitting
                    ? languageData === 'EN'
                      ? 'Loading...'
                      : 'Cargando...'
                    : languageData === 'EN'
                      ? 'Register now'
                      : 'Regístrate Ahora'}
                </Button>
                <FlexContainer className="flex-column ">
                  <Label className="text-12 text-gray text-center lineHeight-1-4">
                    {languageData === 'EN'
                      ? 'By continuing, you agree to our '
                      : 'Al continuar, aceptas nuestros '}
                    <Link
                      to="/terms-conditions"
                      className="text-primary cursor-pointer decoration-none"
                    >
                      {languageData === 'EN' ? 'Terms ' : 'Términos '}
                    </Link>
                    {languageData === 'EN' ? 'and ' : 'y '}
                    <Link
                      to="/privacy-policy"
                      className="text-primary cursor-pointer decoration-none"
                    >
                      {languageData === 'EN'
                        ? 'Privacy Policy '
                        : 'Política de Privacidad '}
                    </Link>
                    .
                  </Label>
                </FlexContainer>
                <FlexContainer className={'justify-center gap-4'}>
                  <Label className={'text-12'}>
                    {languageData === 'EN'
                      ? 'Already have an account?'
                      : '¿Ya tienes una cuenta?'}
                    <Link
                      to="/login"
                      className="text-primary cursor-pointer decoration-none"
                    >
                      {languageData === 'EN' ? ' Sign In ' : ' Inicia Sesión '}
                    </Link>
                  </Label>
                </FlexContainer>
              </Form>
            )}
          </Formik>
        </FlexContainer>
        </Box>
      </FlexContainer>
    </FlexContainer>
  );
};

export default AuthModal;
